import { UTILITY_TARIFF_GROUPS_LIST_PATH, UTILITY_TARIFFS_BASE_PATH } from './constants'
import { utilityTariffVersionEditPath } from './paths'
import type { UtilityTariffGroupTitleRecord } from './types'

export function parseUtilityTariffGroupIdFromApiUrl(url: unknown): number | null {
  if (!url || typeof url !== 'string') {
    return null
  }
  const matchResult = url.match(/\/utility_tariff_groups\/(\d+)\/?/)
  return matchResult ? parseInt(matchResult[1], 10) : null
}

export function formatUtilityTariffGroupTitle(record: UtilityTariffGroupTitleRecord | null | undefined): string {
  if (!record) {
    return ''
  }
  const utility = record.utility_name || ''
  const code = record.code || ''
  if (utility && code) {
    return `${utility} — ${code}`
  }
  return code || utility || record.name || ''
}

export function redirectToTariffVersionEdit(_basePath: unknown, _id: unknown, data: { utility_tariff_group?: string; id?: number } | null | undefined) {
  const gid = parseUtilityTariffGroupIdFromApiUrl(data?.utility_tariff_group)
  if (gid != null && data?.id != null) {
    return utilityTariffVersionEditPath(gid, data.id)
  }
  if (gid != null) {
    return UTILITY_TARIFF_GROUPS_LIST_PATH
  }
  return UTILITY_TARIFFS_BASE_PATH
}

/** Redirect helper for nested catalogue pages — never sends users to the raw tariffs list. */
export function redirectToTariffVersionEditInCatalogue(
  basePath: unknown,
  id: unknown,
  data: { utility_tariff_group?: string; id?: number } | null | undefined
) {
  const target = redirectToTariffVersionEdit(basePath, id, data)
  return target === UTILITY_TARIFFS_BASE_PATH ? UTILITY_TARIFF_GROUPS_LIST_PATH : target
}

export function utilityTariffVersionEditPathForRecord(record: { utility_tariff_group?: string; id?: number } | null | undefined) {
  const gid = parseUtilityTariffGroupIdFromApiUrl(record?.utility_tariff_group)
  if (gid != null && record?.id != null) {
    return utilityTariffVersionEditPath(gid, record.id)
  }
  return null
}
